import {
	GET_EMAIL_LOGS,
	FETCH_EMAIL_LOG,
	GET_EMAILS_DELIVERY_STATS,
} from "constants/actions";

const initialState = {
	emails: [],
	delivery_stats: {},
	pageNumber: 1,
	pending: false,
	queryParams: [],
};

export default function ActionEmail(state = initialState, action) {
	switch (action.type) {
		case GET_EMAIL_LOGS:
			return {
				...state,
				emails: action.payload,
				pending: false,
			};

		case FETCH_EMAIL_LOG:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case GET_EMAILS_DELIVERY_STATS:
			return {
				...state,
				delivery_stats: action.payload,
				pending: false,
			};

		default:
			return state;
	}
}

